export enum PortalStep {
  DataQualityReview = 1,
  FparTables = 0,
  SubmitData = 2,
}
